export default "__VITE_ASSET__a3b4a53e__"